import React from "react";
import { Box, List, ListItem, Button, Paper, useTheme, Typography } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { handleIncrementProduct, handleDecrementProduct } from "../helpers/useArticulos";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ImagenNotFound from "../images/Imagen_not_found.png";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import { imgPath } from "../helpers/imgPath";

const ProductoList = ({ productos, handleDeleteRow, updateProducto, estadoDespacho, isScreenWidthLessThan600, isClienteRemito }) => {
  const theme = useTheme();
  return (
    <Paper
      sx={{
        width: 375,
        marginLeft: -2,
        height: isClienteRemito ? 241 : 250,
        overflow: "auto",
        boxShadow: 0,
        marginBottom: 1,
        marginTop: 0.5,
        "&::-webkit-scrollbar": {
          width: "7px",
        },
        "&::-webkit-scrollbar-track": {
          boxShadow: "inset 0 0 5px grey",
          borderRadius: "7px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#aaa",
          borderRadius: "7px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#888",
        },
      }}
    >
      <List>
        {productos.map(producto => {
          const noEsDespacho = !producto.esDespacho;
          const idProducto = producto.idProducto;
          const imageSource = producto.imagen || imgPath(producto.codigo);
          const imgSrc = imageSource || ImagenNotFound;

          return (
            <ListItem key={producto.idProductoArray} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", justifyContent: "space-between", flex: 1, alignItems: "center" }}>
                {/* Imagen */}
                {noEsDespacho ? (
                  <img
                    src={imgSrc}
                    alt={producto.descripcion || producto.descripcionArticulo || "Producto"}
                    style={{ width: 40, height: 40, objectFit: "contain", marginRight: 8, borderRadius: 6 }}
                  />
                ) : (
                  <LocalGasStationIcon sx={{ width: 40, height: 40, marginLeft: 0.5, objectFit: "contain", marginRight: 1 }} />
                )}
                <span style={{ textTransform: "uppercase", fontSize: 12 }}>{producto.producto || producto.descripcion || producto.descripcionArticulo}</span>
                <div style={{ marginLeft: "auto", fontSize: 16, ...(!noEsDespacho && { marginRight: "4.5rem" }) }}>{`$${producto.importe.toFixed(2)}`}</div>
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center", marginLeft: "auto", marginLeft: 10, marginRight: 5 }}>
                {noEsDespacho && (
                  <>
                    <Box
                      onClick={() => {
                        if (producto.cantidadArticulo !== 1) {
                          handleDecrementProduct(producto.idProductoArray, productos, updateProducto, estadoDespacho);
                        }
                      }}
                      sx={{
                        width: 25,
                        height: 25,
                        borderRadius: "50%",
                        backgroundColor: producto.cantidadArticulo === 1 ? "#E0E0E0" : theme.bandera.colorSecundario,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: producto.cantidadArticulo === 1 ? "default" : "pointer",
                        mr: 1,
                      }}
                    >
                      <RemoveIcon sx={{ color: "#000", fontSize: "1.2rem" }} />
                    </Box>
                    <Typography fontSize={14} sx={{ mx: 1 }}>
                      {producto.cantidadArticulo}
                    </Typography>
                    <Box
                      onClick={() => handleIncrementProduct(producto.idProductoArray, productos, updateProducto)}
                      sx={{
                        width: 25,
                        height: 25,
                        borderRadius: "50%",
                        backgroundColor: theme.bandera.colorSecundario,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <AddIcon sx={{ color: "#000", fontSize: "1.2rem" }} />
                    </Box>
                  </>
                )}
              </div>
              <Button
                variant="contained"
                sx={{
                  boxShadow: 0,
                  fontWeight: "bold",
                  fontSize: 15,
                  backgroundColor: "transparent",
                  minWidth: "10px !important",
                  width: "10px !important",

                  "&:hover": { backgroundColor: "transparent", boxShadow: "none" },
                }}
                onClick={() => handleDeleteRow(producto.idProductoArray, productos, updateProducto, estadoDespacho)}
              >
                <HighlightOffIcon sx={{ color: "grey", fontSize: 25 }} />
              </Button>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default ProductoList;
